import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { tickerWords } from "@/mocks/site";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "热门大瓜", to: "/hot" },
  { label: "投稿入口", to: "/submit" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="hidden h-9 items-center overflow-hidden bg-foreground-950 text-background-100 md:flex">
        <span className="flex h-full shrink-0 items-center gap-2 bg-accent-600 px-4 text-xs font-medium tracking-wide text-background-50">
          <i className="ri-fire-fill text-sm" aria-hidden="true" />
          热瓜速报
        </span>
        <div className="ticker-mask relative flex-1 overflow-hidden">
          <div className="ticker-track">
            {[0, 1].map((round) => (
              <div key={round} className="flex shrink-0 items-center">
                {tickerWords.map((word) => (
                  <span key={`${round}-${word}`} className="flex items-center text-xs text-background-200">
                    <span className="px-5">{word}</span>
                    <span className="text-primary-400">·</span>
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div
        className={`border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/95 backdrop-blur-md"
            : "border-transparent bg-background-50"
        }`}
      >
        <div className="mx-auto flex h-[68px] w-full items-center gap-6 px-4 md:px-6 lg:px-10">
          <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label="瓜友会网首页">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-lg font-bold text-background-50">
              瓜
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-bold tracking-tight text-foreground-950">
                瓜友会网
              </span>
              <span className="mt-1 hidden text-[11px] tracking-[0.2em] text-foreground-500 sm:block">
                GUAYOUHUI
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navLinks.map((item) => {
              const active =
                item.to === "/" ? location.pathname === "/" : location.pathname.startsWith(item.to);
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`whitespace-nowrap rounded-md px-3.5 py-2 text-[15px] transition-colors ${
                    active
                      ? "bg-primary-100 font-medium text-primary-800"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <div className="ml-auto flex items-center gap-3">
            <span className="hidden items-center gap-1.5 text-xs text-foreground-500 lg:flex">
              <span className="relative flex h-2 w-2 items-center justify-center">
                <span className="absolute h-2 w-2 animate-pulse-ring rounded-full bg-accent-500" />
                <span className="h-2 w-2 rounded-full bg-accent-500" />
              </span>
              投稿通道开放中
            </span>
            <Link
              to="/submit"
              className="hidden whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              我要爆料
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-900 transition-colors hover:bg-background-100 md:hidden"
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
            >
              <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`} aria-hidden="true" />
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden">
            <nav className="flex flex-col" aria-label="移动端导航">
              {navLinks.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="border-b border-background-200 py-3.5 text-base text-foreground-800 last:border-none"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
            <Link
              to="/submit"
              className="mt-4 flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
            >
              我要爆料
            </Link>
          </div>
        ) : null}
      </div>
    </header>
  );
}